// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_s9-5";
export var filledCircle = "_s9-4";
export var historyEntry = "_s9-3";
export var messageSideLeft = "_s9-1";
export var messageSideRight = "_s9-2";
export var orderTrackingCarouselWrapper = "_s9-6";
export var orderTrackingInfoContainer = "_s9-0";